<template>
  <div id="app">
    <NavTop/>    
    <router-view/>
    <NavBottom />
  </div>
</template>

<script>
import NavTop from "./components/NavTop";
import NavBottom from "./components/NavBottom";

export default {
  name: 'App',
  components:{
    NavTop,
    NavBottom
  },
}

</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
</style>
